import { render } from "./Apply.vue?vue&type=template&id=bd28f426"
import script from "./Apply.vue?vue&type=script&lang=js"
export * from "./Apply.vue?vue&type=script&lang=js"
script.render = render

export default script